import en from './en';

export const defaultNS = 'common';
export const namespaces = Object.keys(en);
export const resources = { en } as const;
